import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class Cell extends PureComponent {
  render() {
    const { className, children,
      active, access, link,
      checkbox, radio, select, selectBefore, selectAfter, vcode, sw,
      readOnly, disabled, href, component, htmlFor, ...others } = this.props;
    const DefaultComponent = href ? "a" : htmlFor ? "label" : "div";
    const CellComponent = component ? component : DefaultComponent;
    
    const cls = classNames({
      "weui-cell": true,
      "weui-cell_active": active,
      "weui-cell_access": access,
      "weui-cell_link": link,
      "weui-cell_readonly": readOnly,
      "weui-cell_disabled": disabled,
      "weui-check__label": checkbox || radio,
      "weui-cell_switch": sw,
      "weui-cell_select": select || selectBefore || selectAfter,
      "weui-cell_select-before": selectBefore,
      "weui-cell_select-after": selectAfter,
      "weui-cell_vcode": vcode,
      "weui-cell_wrap": vcode
    }, className);

    return (
      <CellComponent className={ cls } href={ href } htmlFor={ htmlFor } { ...others }>
        { children }
      </CellComponent>
    );
  }
}

